import { render, staticRenderFns } from "./CommentView.vue?vue&type=template&id=2f35896b"
import script from "./CommentView.vue?vue&type=script&lang=js"
export * from "./CommentView.vue?vue&type=script&lang=js"
import style0 from "./CommentView.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports